export class AccountMetricsDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsAccountMetricsDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountMetricsDestination.attributeTypeMap;
    }
    constructor() {
    }
}
